<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">
    <header class="ledger-header"><div><h2>Buku Besar</h2><p>{{ company.name }} &middot; {{ startDate }} sampai {{ endDate }}</p></div><span class="ledger-basis">Jurnal POSTED &middot; Rupiah (IDR)</span></header>
    <vs-alert v-if="ledgerError" color="danger" class="mt-4" role="alert"><strong>Buku besar belum dapat ditampilkan</strong><p>{{ ledgerError }}</p><vs-button size="small" :disabled="!loaded" @click="refreshData">Coba lagi</vs-button></vs-alert>
    <div class="ledger-sync-status mt-4" aria-live="polite">
      <vs-alert v-if="openingSyncMessage" :color="openingSyncFailed || openingSyncWarning ? 'warning' : 'primary'">
        <div class="ledger-sync-heading">
          <span>{{ openingSyncFailed ? 'Saldo awal belum diperbarui' : 'Status saldo awal' }}</span>
          <vs-button v-if="openingSyncFailed && canSyncOpening" size="small" :disabled="!loaded" @click="retryOpeningSync">Perbarui lagi</vs-button>
        </div>
        <p class="ledger-sync-summary">{{ openingSyncMessage }}</p>
        <div v-if="openingSyncReasons.length" class="ledger-sync-reasons">
          <strong>Alasan dan langkah perbaikan</strong>
          <ol>
            <li v-for="(reason, index) in openingSyncReasons" :key="`${reason.code || 'reason'}-${index}`">
              <strong v-if="reason.account">{{ reason.account_code ? `${reason.account_code} · ` : '' }}{{ reason.account }}: </strong>{{ reason.message }}
              <span v-if="reason.action" class="ledger-sync-action">{{ reason.action }}</span>
              <router-link v-if="reason.path && canSyncOpening" :to="reason.path" class="ledger-sync-link">Buka {{ reason.path === '/report-settings' ? 'Atur Laporan' : 'Manage COA' }}</router-link>
            </li>
          </ol>
        </div>
      </vs-alert>
      <vs-alert v-if="profitSyncMessage" :color="profitSyncFailed ? 'warning' : 'primary'">
        <div class="ledger-sync-heading">
          <span>{{ profitSyncFailed ? 'Laba berjalan belum diperbarui' : 'Status laba berjalan' }}</span>
          <vs-button v-if="profitSyncFailed && !openingSyncFailed && canSyncOpening" size="small" :disabled="!loaded" @click="retryOpeningSync">Coba lagi</vs-button>
        </div>
        <details class="ledger-sync-detail"><summary>Lihat keterangan laba berjalan</summary><p>{{ profitSyncMessage }}</p></details>
      </vs-alert>
    </div>

    <vx-card ref="filterCard" title="Periode dan pencarian" class="user-list-filters mt-6" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Cari Data</label>
          <vs-input class="mb-4 md:mb-0 w-full" v-model="searchQuery" @input="updateSearchQuery" placeholder="Masukkan kata kunci..." />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Bulan awal</label>
          <div class="flex items-center">
                 <vs-button icon @click="prevMonthStart" :disabled="selectedIndexStart === 0">‹</vs-button>

              <vs-select v-model="selectedMonthStart" class="mx-3" @change="handleSelectMonthStart" style="width: 150px">
                <vs-select-item
                  v-for="(month, index) in months"
                  :key="index"
                  :value="month.value"
                  :text="month.label"
                />
              </vs-select>

              <vs-button icon @click="nextMonthStart" :disabled="selectedIndexStart === months.length - 1">›</vs-button>
              </div>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Bulan akhir</label>
          <div class="flex items-center">
                 <vs-button icon @click="prevMonthEnd" :disabled="selectedIndexEnd === 0">‹</vs-button>

              <vs-select v-model="selectedMonthEnd" class="mx-3" @change="handleSelectMonthEnd" style="width: 150px">
                <vs-select-item
                  v-for="(month, index) in months"
                  :key="index"
                  :value="month.value"
                  :text="month.label"
                />
              </vs-select>

              <vs-button icon @click="nextMonthEnd" :disabled="selectedIndexEnd === months.length - 1">›</vs-button>
              </div>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <!-- <vs-button @click="printGL" class="mt-6 mx-1" color="primary" type="filled">Print</vs-button> -->
          <vs-button :disabled="!loaded || !!ledgerError" @click="attachmentDownload" class="mt-6 mx-1 text-sm" color="primary" type="filled">Lampiran PDF</vs-button>
          <vs-dropdown>
              <vs-button :disabled="!loaded || !!ledgerError" color="success" type="filled" class="text-sm mt-6 mx-1">
                Unduh laporan
              </vs-button>
              <vs-dropdown-menu class="w-48">
                <vs-dropdown-item @click="printGL">
                  <i class="bx bxs-file-pdf mr-2 text-red-600"></i> Cetak PDF
                </vs-dropdown-item>
                <vs-dropdown-item @click="exportExcelGL">
                  <i class="bx bxs-file-export mr-2 text-green-600"></i>Excel Buku Besar
                </vs-dropdown-item>
                <vs-dropdown-item @click="exportExcelSubGL">
                  <i class="bx bxs-file-export mr-2 text-green-600"></i>Excel Rincian
                </vs-dropdown-item>
                <!-- <vs-dropdown-item @click="attachmentDownload">
                  <i class="bx bxs-file-export mr-2 text-green-600"></i>Attachment
                </vs-dropdown-item> -->
              </vs-dropdown-menu>
            </vs-dropdown>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6 pt-3 mt-6" style="min-height: 100%" v-show="loaded">
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="glData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :enableRtl="$vs.rtl"
        :frameworkComponents="frameworkComponents">
      </ag-grid-vue>

    </div>

    <div class="vx-card p-6 pt-3" id="GLPrint" style="display: none;">
      <table width="100%" style="border-collapse: collapse; font-family: roboto;">
        <thead>
            <tr>
                <th colspan="6"><h2><b>{{ company.name }}</b></h2></th>
            </tr>
            <tr>
                <th style="font-size: 18px; font-weight: 100;" colspan="6"><h3>General Ledger</h3></th>
            </tr>
            <tr>
                <th style="font-size: 18px; font-weight: 100;" colspan="6"><h4 id="report-data-date">{{ startDate }} to {{ endDate }}</h4></th>
            </tr>
            <tr>
                <th colspan="6">&nbsp;</th>
            </tr>
            <tr>
                <th width="10%">CODE</th>
                <th width="50%">ACCOUNT NAME</th>
                <th width="10%">BEGINNING BALANCE</th>
                <th width="10%">DEBIT</th>
                <th width="10%">CREDIT</th>
                <th width="10%">ENDING BALANCE</th>
            </tr>
        </thead>
        <tbody id="report-data">
          <template v-for="item in glData">
            <tr :key="item.id">
                <td style="padding: 5px;">{{ item.code }}</td>
                <td :style="(item.level == 1) ? 'padding: 5px 5px 5px 0' : (item.level == 2) ? 'padding: 5px 5px 5px 30px' : (item.level == 3) ? 'padding: 5px 5px 5px 50px' : 'padding: 5px 5px 5px 70px'">{{ item.name }}</td>
                <td style="text-align: right; padding: 5px;">{{ item.init }}</td>
                <td style="text-align: right; padding: 5px;">{{ item.debit }}</td>
                <td style="text-align: right; padding: 5px;">{{ item.credit }}</td>
                <td style="text-align: right; padding: 5px;">{{ item.final }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'

import Vue from 'vue'
import VueHtmlToPaper from 'vue-html-to-paper'
const options = {
  name: '',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  autoClose: true,
  windowTitle: window.document.title
}
Vue.use(VueHtmlToPaper, options)

// Store Module
import moduleGL from '@/store/general-ledger/moduleGL.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import axios from '@/axios.js'


export default {
  components: {
    AgGridVue,
    vSelect,
    StatisticsCardLine,
    Datepicker,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data () {
    return {

      // Filter Options
      typeFilter: { label: 'All', value: 'all' },
      typeOptions: [
        { label: 'All', value: 'all' },
        { label: 'Kas Masuk', value: 'KM' },
        { label: 'Kas Keluar', value: 'KK' }
      ],
      startDate: moment([Number(localStorage.getItem('selectedYear')), 0, 1]).format('YYYY-MM-DD'),
      endDate: moment([Number(localStorage.getItem('selectedYear')), 11, 31]).format('YYYY-MM-DD'),
      searchQuery: '',
      selectedMonthStart: '01',
      selectedMonthEnd: '12',
      months: [
        { label: 'Januari', value: '01' },
        { label: 'Februari', value: '02' },
        { label: 'Maret', value: '03' },
        { label: 'April', value: '04' },
        { label: 'Mei', value: '05' },
        { label: 'Juni', value: '06' },
        { label: 'Juli', value: '07' },
        { label: 'Agustus', value: '08' },
        { label: 'September', value: '09' },
        { label: 'Oktober', value: '10' },
        { label: 'November', value: '11' },
        { label: 'Desember', value: '12' }
      ],

      loaded: false,
      ledgerError: '',
      openingSyncMessage: '',
      openingSyncReasons: [],
      openingSyncFailed: false,
      openingSyncWarning: false,
      profitSyncMessage: '',
      profitSyncFailed: false,
      openingSyncRequests: {},
      ledgerRequestId: 0,
      glData: [],
      // company: JSON.parse(localStorage.getItem('activeCompany')),
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        autoHeight: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'Kode Akun',
          field: 'code',
          filter: true,
          width: 130
        },
        {
          headerName: 'Nama Akun',
          field: 'name',
          filter: true,
          width: 400,
          cellRendererFramework: 'CellRendererLink',
          cellStyle: { 'white-space': 'normal', 'line-height': 1.5 },
          cellClass (params) {
            return `level-${params.data.level}`
          }
        },
        {
          headerName: 'Saldo Awal',
          field: 'init',
          filter: true,
          width: 150
        },
        {
          headerName: 'Debit',
          field: 'debit',
          filter: true,
          width: 150,
          cellStyle: { 'white-space': 'normal', 'line-height': 1.5 }
        },
        {
          headerName: 'Kredit',
          field: 'credit',
          filter: true,
          width: 150
        },
        {
          headerName: 'Saldo Akhir',
          field: 'final',
          filter: true,
          width: 150
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  watch: {
    typeFilter (obj) {
      this.setColumnFilter('type', obj.value)
    }
  },
  computed: {
    canSyncOpening () {
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}')
      return user.role_id !== undefined && user.role_id !== null && [0, 1].includes(Number(user.role_id))
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    company () {
      return JSON.parse(localStorage.getItem('activeCompany'))
    },
    selectedIndexStart () {
      return this.months.findIndex(m => m.value === this.selectedMonthStart)
    },
    selectedIndexEnd () {
      return this.months.findIndex(m => m.value === this.selectedMonthEnd)
    }
  },
  methods: {
    async printGL () {
      if (!this.loaded || this.ledgerError || !this.validatePeriod()) return
      const self = this
      await self.$htmlToPaper('GLPrint')
    },
    loading () {
      this.loaded = false

      this.$vs.loading({
        type: 'border',
        color: 'primary',
        text: 'Wait a minute, It\'s getting data.'
      })
    },
    validatePeriod () {
      const start = moment(this.startDate, ['YYYY-MM-DD', 'DD-MM-YYYY'], true)
      const end = moment(this.endDate, ['YYYY-MM-DD', 'DD-MM-YYYY'], true)
      let message = ''
      if (!start.isValid() || !end.isValid()) message = 'Tanggal awal dan akhir harus valid.'
      else if (start.isAfter(end)) message = 'Tanggal akhir tidak boleh sebelum tanggal awal.'
      else if (start.year() !== end.year()) message = 'Pilih rentang tanggal dalam satu tahun buku.'
      if (message) {
        this.$vs.notify({ color: 'warning', title: 'Peringatan', text: message })
        return false
      }
      this.startDate = start.format('YYYY-MM-DD')
      this.endDate = end.format('YYYY-MM-DD')
      this.selectedMonthStart = start.format('MM')
      this.selectedMonthEnd = end.format('MM')
      return true
    },
    filterDateLastYear () {
      const year = Number(localStorage.getItem('selectedYear')) - 1
      this.startDate = moment([year, 0, 1]).format('YYYY-MM-DD')
      this.endDate = moment([year, 11, 31]).format('YYYY-MM-DD')
      this.filterDate()
    },
    retryOpeningSync () {
      this.openingSyncRequests = {}
      this.loading()
      this.getGL()
    },
    async getGL () {
      if (!this.validatePeriod()) {
        ++this.ledgerRequestId
        this.glData = []
        this.onLoaded()
        return
      }
      this.ledgerError = ''
      const self      = this
      // const userData  = this.$store.state.AppActiveUser
      const company = JSON.parse(localStorage.getItem('activeCompany'))
      const requestId = ++this.ledgerRequestId
      this.profitSyncMessage = ''
      this.profitSyncFailed = false
      this.openingSyncWarning = false
      this.openingSyncReasons = []
      const startDate = self.startDate
      const endDate = self.endDate
      const year = Number(moment(startDate, ['YYYY-MM-DD', 'DD-MM-YYYY'], true).format('YYYY'))
      self.glData = []
      if (this.canSyncOpening && company && Number.isInteger(year)) {
        const key = `${company.id}:${year}`
        if (!this.openingSyncRequests[key]) {
          this.openingSyncMessage = `Sinkronisasi saldo awal ${year - 1} → ${year}...`
          this.openingSyncFailed = false
          this.openingSyncRequests[key] = axios.post(`/general-ledger/${company.id}/sync-opening`, { year }, { headers: { 'X-Year': String(year) } })
            .then(res => ({ data: res.data.data }))
            .catch(error => {
              const response = error.response && error.response.data
              return { error: (response && response.message) || 'Koneksi sync gagal.', reasons: (response && response.reasons) || [] }
            })
        }
        const sync = await this.openingSyncRequests[key]
        if (requestId !== this.ledgerRequestId) return
        this.openingSyncFailed = !!sync.error
        if (sync.error) {
          this.openingSyncMessage = `Saldo awal ${year} belum diperbarui; buku besar menampilkan saldo tersimpan.`
          this.openingSyncReasons = sync.reasons.length ? sync.reasons : [{ code: 'SYNC_FAILED', message: sync.error }]
        } else if (sync.data.status === 'BASE_YEAR') {
          this.openingSyncMessage = sync.data.message
        } else {
          this.openingSyncMessage = `Saldo awal ${year} tersinkronisasi (${sync.data.changed_accounts} akun berubah). Terakhir: ${sync.data.synced_at}`
          if (sync.data.warnings && sync.data.warnings.length) {
            this.openingSyncWarning = true
            const differences = sync.data.warnings.map(warning => new Intl.NumberFormat('id-ID').format(warning.difference)).join(', ')
            this.openingSyncMessage += ` Laba menggunakan hasil engine; selisih terhadap saldo representasi legacy: Rp${differences}. Detail tersimpan di audit sync.`
          }
        }
      } else {
        this.openingSyncMessage = 'Menampilkan saldo tersimpan. Sinkronisasi hanya dapat dilakukan admin company.'
        this.openingSyncFailed = false
      }

      // Independent of carry-forward: an opening-sync failure must not prevent
      // refreshing the current year's derived profit cache.
      if (this.canSyncOpening && company && Number.isInteger(year)) {
        try {
          const response = await axios.post(`/general-ledger/${company.id}/refresh-current-profit`, {}, { headers: { 'X-Year': String(year) } })
          if (requestId !== this.ledgerRequestId) return
          const profit = response.data.data
          this.profitSyncMessage = profit.status === 'NOT_CONFIGURED' ? 'Pilih akun Laba/Rugi Tahun Berjalan di Atur Laporan untuk tahun aktif.' : `Saldo akhir akun laba berjalan sesuai Income Statement tahun ${year}.`
        } catch (error) {
          if (requestId !== this.ledgerRequestId) return
          this.profitSyncFailed = true
          const message = (error.response && error.response.data && error.response.data.message) || 'Koneksi gagal.'
          this.profitSyncMessage = message
        }
      }

      return this.$store.dispatch('gl/fetchGL', {
        companyId: company.id,
        startDate,
        endDate
      })
        .then(res => {
          if (requestId !== this.ledgerRequestId) return

          const data = res.data.data

          if (data.length > 0) {

            data.forEach(value => {
              self.glData.push({
                id      : value.id,
                level   : value.level,
                code    : value.account_code,
                name    : value.name,
                init    : new Intl.NumberFormat('id-ID').format(value.init_balance),
                debit   : new Intl.NumberFormat('id-ID').format(value.debit),
                credit  : new Intl.NumberFormat('id-ID').format(value.credit),
                final   : new Intl.NumberFormat('id-ID').format(value.final_balance),
                startDate,
                endDate
              })
            })
          } else {
            self.glData = []
          }
        })
        .catch(err => {
          if (requestId !== this.ledgerRequestId) return
          this.ledgerError = (err.response && err.response.data && err.response.data.message) || 'Koneksi gagal. Silakan coba lagi.'
          this.$vs.notify({
            color: 'danger',
            title: 'Laporan belum tersedia',
            text: this.ledgerError
          })
        })
        .finally(() => {
          if (requestId === this.ledgerRequestId) this.onLoaded()
        })
    },
    async exportExcelGL () {
      if (this.loaded === false || this.ledgerError || !this.validatePeriod()) return
      const startDate = this.startDate
      const endDate = this.endDate
      try {
        const response = await axios.get(`general-ledger/${this.company.id}/export-gl`, {
          params: {
            start_date: startDate,
            end_date: endDate
          },
          responseType: 'blob'
        })

        // Format tanggal untuk nama file
        const formatDateForFilename = (dateString) => {
          const [year, month, day] = dateString.split('-')
          return `${day}-${month}-${year}`
        }

        const formattedStartDate = formatDateForFilename(startDate)
        const formattedEndDate = formatDateForFilename(endDate)

        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/vnd.ms-excel'
        })

        const safeCompanyName = this.company.name.replace(/[^a-zA-Z0-9]/g, '_')
        const fileName = `${safeCompanyName}_general-ledger_${formattedStartDate}_to_${formattedEndDate}.xls`

        // Create download link
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        // Clean up
        setTimeout(() => {
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        }, 100)

      } catch (err) {
        // Tambahkan notifikasi error ke user
        this.$vs.notify({
          color: 'danger',
          title: 'Export Gagal',
          text: 'Terjadi kesalahan saat mengekspor data'
        })
      }
    },
    async exportExcelSubGL () {
      if (this.loaded === false || this.ledgerError || !this.validatePeriod()) return
      const startDate = this.startDate
      const endDate = this.endDate
      try {
        const response = await axios.get(`general-ledger/${this.company.id}/export-sub-gl`, {
          params: {
            start_date: startDate,
            end_date: endDate
          },
          responseType: 'blob'
        })

        // Format tanggal untuk nama file
        const formatDateForFilename = (dateString) => {
          const [year, month, day] = dateString.split('-')
          return `${day}-${month}-${year}`
        }

        const formattedStartDate = formatDateForFilename(startDate)
        const formattedEndDate = formatDateForFilename(endDate)

        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/vnd.ms-excel'
        })

        const fileName = `neraca-sub-ledger_${formattedStartDate}_to_${formattedEndDate}.xls`

        // Create download link
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        // Clean up
        setTimeout(() => {
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        }, 100)

      } catch (err) {
        // Tambahkan notifikasi error ke user
        this.$vs.notify({
          color: 'danger',
          title: 'Export Gagal',
          text: 'Terjadi kesalahan saat mengekspor data'
        })
      }
    },
    async attachmentDownload () {
      if (this.loaded === false || this.ledgerError || !this.validatePeriod()) return
      const startDate = this.startDate
      const endDate = this.endDate
      try {
        const response = await axios.get(`general-ledger/${this.company.id}/download-attachment`, {
          params: {
            start_date: startDate,
            end_date: endDate
          },
          responseType: 'blob' // penting agar file tidak korup
        })

        // Format tanggal untuk nama file
        const formatDateForFilename = (dateString) => {
          const [year, month, day] = dateString.split('-')
          return `${day}-${month}-${year}`
        }

        const formattedStartDate = formatDateForFilename(startDate)
        const formattedEndDate = formatDateForFilename(endDate)

        // buat blob PDF
        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/pdf'
        })

        const safeCompanyName = this.company.name.replace(/[^a-zA-Z0-9]/g, '_')
        const fileName = `${safeCompanyName}_general-ledger_${formattedStartDate}_to_${formattedEndDate}.pdf`

        // Buat link download sementara
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        // Bersihkan
        setTimeout(() => {
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        }, 100)

      } catch (err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Download Gagal',
          text: 'Terjadi kesalahan saat mengunduh file PDF'
        })
      }
    },
    onLoaded () {
      this.loaded = true
      this.$vs.loading.close()
    },
    refreshData () {
      this.loading()
      return this.getGL()
    },
    filterDate () {
      if (!this.validatePeriod()) return
      const elem = this.$refs.btnDropdown
      if (elem) elem.click()
      return this.refreshData()
    },
    formatRupiah (value) {
      const val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.typeFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    prevMonthStart () {
      if (this.selectedIndexStart > 0) {
        this.selectedMonthStart = this.months[this.selectedIndexStart - 1].value
        return this.handleSelectMonthStart()
      }
    },
    nextMonthStart () {
      if (this.selectedIndexStart < this.months.length - 1) {
        this.selectedMonthStart = this.months[this.selectedIndexStart + 1].value
        return this.handleSelectMonthStart()
      }
    },
    handleSelectMonthStart () {
      const year = moment(this.startDate, ['YYYY-MM-DD', 'DD-MM-YYYY'], true).year()
      const start = moment([year, Number(this.selectedMonthStart) - 1, 1])
      this.startDate = start.format('YYYY-MM-DD')
      if (start.isAfter(moment(this.endDate, ['YYYY-MM-DD', 'DD-MM-YYYY'], true))) {
        this.endDate = start.clone().endOf('month').format('YYYY-MM-DD')
      }
      return this.refreshData()
    },
    prevMonthEnd () {
      if (this.selectedIndexEnd > 0) {
        this.selectedMonthEnd = this.months[this.selectedIndexEnd - 1].value
        return this.handleSelectMonthEnd()
      }
    },
    nextMonthEnd () {
      if (this.selectedIndexEnd < this.months.length - 1) {
        this.selectedMonthEnd = this.months[this.selectedIndexEnd + 1].value
        return this.handleSelectMonthEnd()
      }
    },
    handleSelectMonthEnd () {
      const year = moment(this.endDate, ['YYYY-MM-DD', 'DD-MM-YYYY'], true).year()
      const end = moment([year, Number(this.selectedMonthEnd) - 1, 1]).endOf('month')
      this.endDate = end.format('YYYY-MM-DD')
      if (end.isBefore(moment(this.startDate, ['YYYY-MM-DD', 'DD-MM-YYYY'], true))) {
        this.startDate = end.clone().startOf('month').format('YYYY-MM-DD')
      }
      return this.refreshData()
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    this.gridOptions.api.setDomLayout('autoHeight')
    this.gridOptions.api.sizeColumnsToFit()
    // this.gridOptions.api.resetRowHeights()
    // this.gridOptions.api.showLoadingOverlay()
  },
  created () {
    if (!moduleGL.isRegistered) {
      this.$store.registerModule('gl', moduleGL)
      moduleGL.isRegistered = true
    }
    this.loading()
    this.getGL()
  }
}

</script>

<style lang="scss">
.ledger-header { display: flex; justify-content: space-between; align-items: center; gap: 16px; flex-wrap: wrap; margin: 12px 0 24px; }
.ledger-header p { color: #5d687a; margin-top: 8px; }
.ledger-basis { background: #eef2f7; color: #344258; border-radius: 6px; padding: 8px 12px; font-size: 12px; }

.ledger-sync-status {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  > * { flex: 1 1 300px; min-width: 0; }
}
.ledger-sync-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; font-weight: 600; }
.ledger-sync-summary { margin-top: 8px; line-height: 1.5; overflow-wrap: anywhere; }
.ledger-sync-reasons { margin-top: 12px; }
.ledger-sync-reasons ol { margin: 8px 0 0; padding-left: 22px; }
.ledger-sync-reasons li { margin-bottom: 10px; line-height: 1.5; overflow-wrap: anywhere; }
.ledger-sync-action { display: block; }
.ledger-sync-link { display: inline-block; margin-top: 4px; font-weight: 600; text-decoration: underline; }
.ledger-sync-detail { margin-top: 6px; overflow-wrap: anywhere; }
.ledger-sync-detail summary { cursor: pointer; font-size: 12px; }
.ledger-sync-detail p { margin-top: 8px; line-height: 1.6; }
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.filter-date {
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #111;
  border-radius: 5px;
  padding: 10px;
}

.ag-grid-table {
  height: 100%;
}

.ag-theme-material .ag-row-selected {
  background-color: var(--app-secondary-border);
}

.ag-row .ag-cell {
  display: flex;
  align-items: center;
}

.ag-row .level-2 {
  padding-left: 50px;
}

.ag-row .level-3 {
  padding-left: 70px;
}

.ag-row .level-4 {
  padding-left: 90px;
}
</style>
